// import UserBankAccounts from "./UserBankAccounts";
import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Tabs, { Tab } from "react-best-tabs";
import "react-best-tabs/dist/index.css";
import CustomTable from "../../components/DataTable/CustomTable";
import TableHeader from "../../components/DataTable/TableHeader";
import { UserPlus } from "lucide-react";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Accounts from "./Accounts";
import { useEffect } from "react";

import { serialNumber } from "../../utils/helper";
import { getallbanktobankTransaction } from "../../services/authapi";
import ActionButtons from "../../components/DataTable/ActionButtons";
import { toast } from "react-toastify";
import ConfirmAlert from "../../components/ConfirmAlert";
import { AccountDetailCard } from "../../components/ItemDetail";
import { createColumnHelper } from "@tanstack/react-table";

const CashDepositwithdraw = ({ checkPermission }) => {
  const columnHelper = createColumnHelper();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { userPermission } = useSelector(selectUser);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("last_tab") || "2"
  );
  const pageNo = searchParams.get("pageNo") || 1;
  const pageSize = searchParams.get("pageSize") || 10;
  const [search, setSearch] = useState("");
  const user_id = useSelector((state) => state.auth.user.id);
  const user_type = useSelector((state) => state.auth.user.user_type);
  const [idToDelete, setIdToDelete] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [transactionType, setTransactiontype] = useState("");

  const handleClick = (e, tab) => {
    setActiveTab(tab);
    if (searchParams.has("pageNo")) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("pageNo");
      navigate({
        pathname: location.pathname,
        search: newParams.toString(),
      });
    }
    localStorage.setItem("last_tab", tab);
  };
  const columns = [
    columnHelper.accessor("sr_no", {
      header: t("Sr No."),
      cell: (info) => {
        const serialNumbers = serialNumber(pageNo, pageSize);
        return serialNumbers[info.row.index];
      },
    }),
    {
      header: "Transaction Category",
      accessorKey: "txn_category",
      cell: ({ row }) => {
        const category = row.original.txn_category;

        switch (category) {
          case "DB":
            return " Firm Bank Deposit";
          case "WU":
            return "User Bank Withdrawal";
          case "DC":
            return "Creditors Bank Deposit";
          case "DU":
            return "User Bank Deposit";
          case "UB":
            return "User to Bank";
          case "CB":
            return "Creditor to Bank";
          case "CW":
            return "Creditor Bank Withdrawal";
          case "BW":
            return "Firm Bank Withdrawal";
          default:
            return category || "User to User";
        }
      },
    },
    {
      header: "Transaction Date",
      accessorFn: (row) => {
        const rawDate = row.bank_txn_date || row.user_txn_date;
        if (!rawDate) return "-";

        const date = new Date(rawDate);
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
      },
    },
    // {
    //     header: "From Account Details",
    //     accessorKey: "from_bank_account_holder_name", // placeholder, main accessorFn use karenge
    //     cell: ({ row }) => {
    //         const data = row.original;

    //         // Bank transaction
    //         if (data.from_bank_account_holder_name) {
    //             return (
    //                 <AccountDetailCard
    //                     name={data.from_bank_account_holder_name}
    //                     accountNumber={data.from_bank_account_number}
    //                     bankName={`${data.from_bank_name} | Balance: ₹${data.from_bank_balance || 0
    //                         }`}
    //                 />
    //             );
    //         }

    //         // User-to-User transaction
    //         if (data.from_user_name) {
    //             return (
    //                 <AccountDetailCard
    //                     name={data.from_user_name}
    //                     accountNumber={data.from_user_account_number}
    //                     bankName={`${data.from_user_bank_name} | Balance: ₹${data.from_user_bank_balance || 0
    //                         }`}
    //                 />
    //             );
    //         }

    //         return "-"; // default fallback
    //     },
    // },

    {
      header: " Account Details",
      accessorKey: "to_account_details", // placeholder
      cell: ({ row }) => {
        const data = row.original;

        // Bank to Bank / Bank to Creditor
        if (data.to_bank_account_holder_name) {
          return (
            <AccountDetailCard
              name={data.to_bank_account_holder_name}
              accountNumber={data.to_bank_account_number}
              bankName={`${data.to_bank_name} | Balance: ₹ ${Number(data.to_bank_balance || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
            />
          );
        }

        // Bank to User / User to User
        if (data.to_user_name) {
          return (
            <AccountDetailCard
              name={data.to_user_name}
              accountNumber={data.to_user_account_number}
              bankName={`${data.to_user_bank_name} | Balance: ₹${
                Number(data.to_user_balance || data.to_user_bank_balance || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              }`}
            />
          );
        }

        return "-";
      },
    },

    {
      header: "Transaction ID",
      accessorFn: (row) => row.bank_txn_id || row.transaction_id || "-",
    },
    {
      header: "Amount",
      accessorFn: (row) => row.bank_amount || row.user_amount || "-",
      cell: ({ row }) => {
        const amount = row.original.bank_amount || row.original.user_amount;
        return amount !== undefined ? (
          <span style={{ color: "green" }} className="fw-bold">
            ₹ {Number(amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        ) : (
          "-"
        );
      },
    },

    // {
    //     header: "Payment Mode",
    //     accessorFn: (row) => row.payment_mode || "-",
    // },
    {
      header: "Status",
      accessorFn: (row) => row.bank_txn_status || row.user_txn_status || "-",
    },
      {
                header: "Remark",
                accessorFn: (row) => row.remark || "-",
            },

    columnHelper.accessor("action", {
      header: t("Action"),
      cell: (info) => (
        <ActionButtons
          actions={{
            // view: {
            //     show: checkPermission?.view,
            //     action: () =>
            //         navigate(
            //             `/account-management/view-transaction/${info.row.original?.id}?type=details&isuser=true&iscreditor=true`
            //         ),
            // },
            edit: {
              show: checkPermission?.update,
              action: () =>
                navigate(`/add_cash_withdraw_deposit/${info.row.original?.id}`),
            },
            // delete: {
            //     show: checkPermission?.delete,
            //     action: () => {
            //         setIdToDelete(`${info.row.original?.id}`);
            //         setShowAlert(true);
            //         setTransactiontype(info.row.original?.txn_category);
            //     },
            // },
          }}
        />
      ),
    }),
  ];
  const fetchallbankTransactions = async () => {
     setIsLoading(true);
    const params = {
      pageNo,
      pageSize,
      search,
      user_id: user_id,
      user_type: user_type,
      is_cash_transaction: true,
    };
    const res = await getallbanktobankTransaction(params);
    if (res?.status) {
      // const data = res.data.filter((item) => item.account_number);
      setRows(res?.data);

      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchallbankTransactions();
  }, [search, pageNo, pageSize]);

  return (
    <>
      <CustomTable
        id={"transferred_fund"}
        userPermission={checkPermission}
        isLoading={isLoading}
        rows={rows || []}
        columns={columns}
        pagination={{
          pageNo,
          pageSize,
          totalData,
        }}
        excelAction={() => ""}
        pdfAction={() => ""}
        //    apiForExcelPdf={getAllTransferFundRequest}
        customHeaderComponent={() => (
          <TableHeader
            userPermission={checkPermission}
            setSearchText={setSearch}
            button={{
              show: true,
              to: `/add_cash_withdraw_deposit`,
              title: "Create",
            }}
          />
        )}
        tableTitleComponent={
          <div>
            <UserPlus /> <strong>Cash Deposit/Withdraw</strong>
          </div>
        }
      />
    </>
  );
};

export default CashDepositwithdraw;

// show: false ,
